import { Component, OnInit, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { SessionStorageService } from '../../services/session-storage.service';
import { map } from 'rxjs/operators';
import { UnifiedFlowService } from '../unified.service';
import { AdminService } from '../../admin/admin.service';
import { UniversalSearchService } from '../../universal-search/services/universal-search.service';

import { RbGridComponent } from '../../shared-components/rb-grid/rb-grid.component';

@Component({
  selector: 'app-unified-flow-search',
  templateUrl: './unified-flow-search.component.html',
  styleUrls: ['./unified-flow-search.component.scss'],
  standalone: true,
  imports: [RbGridComponent],
})
export class UnifiedFlowSearchComponent implements OnInit {
  private router = inject(Router);
  private unfFlowSvc = inject(UnifiedFlowService);
  private usService = inject(UniversalSearchService);
  private ss = inject(SessionStorageService);
  private adminService = inject(AdminService);

  rows = [];
  public search = '';
  searchControl = new FormControl();
  dataSource = [];
  rights = [];
  gridConfig = {
    title: 'Case Search',
    gridName: 'CaseSearch',
    showGridFilters: true,
    showFilterManager: false,
    manualSearch: true,
    searchButtonText: 'Search Results',
    downloadGridButton: true,
    downloadGridButtonProps: {
      icon: 'cloud_download',
      text: 'Download Case Search',
      action: 'application/xlsx',
      payloadOverride: { take: 1000, skip: 0 },
    },
    gridActionColumn: true,
    showGridColumnFilters: true,
    omitCols: [
      'profileId',
      'caseCompleted',
      'ciStatus',
      'ppStatus',
      'awStatus',
      'iwStatus',
      'lwStatus',
      'unitId',
      'userId',
      'repCode',
    ],
    breadcrumb: [
      {
        label: 'Case Search',
        link: 'search',
      },
    ],
  };

  ngOnInit(): void {
    this.rights = this.ss.get('rights');
  }

  getGridSetup() {
    return this.adminService.getUIConfigHeaders({
      uiconfig: 'shared-json',
      type: 'case-search',
      implementation: 'rb',
    });
  }

  getGridData(payload, responseType = 'application/json') {
    return this.usService.caseSearch(payload, responseType);
  }

  handleSelect(result) {
    if (result.option.value) {
      this.search = result.option.value.Name;
      this.rows = this.rows.filter(x => {
        return (
          x.Name === result.option.value.Name ||
          x.caseNumber === result.option.value.caseNumber
        );
      });
    } else {
      this.rows = this.dataSource;
      this.searchControl.setValue('');
    }
  }

  onSelect(e) {
    let id;
    let app = e.app ? e.app : 'rb';

    if (e.id) {
      id = e.id;
      app = e.app;
      this.router.navigate([`/case/${app}/${id}/0`]);
    } else {
      id = e;

      this.unfFlowSvc
        .getApps(id)
        .pipe(
          map(x => x?.Modules),
          map(apps => {
            return apps.filter(x => {
              return (
                x.vars.ModuleStatus.FlowStatus === 'O' ||
                x.vars.ModuleStatus.FlowStatus === 'C'
              );
            });
          })
        )
        .subscribe(z => {
          app = z[0].name.toLowerCase();
          this.router.navigate([`/case/${app}/${id}/0`]);
        });
    }
  }
}
